import { render } from "./UnitForm.vue?vue&type=template&id=58cef06f&scoped=true"
import script from "./UnitForm.vue?vue&type=script&lang=js"
export * from "./UnitForm.vue?vue&type=script&lang=js"

import "./UnitForm.vue?vue&type=style&index=0&id=58cef06f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cef06f"]])

export default __exports__